import {
  JsonapiEntity,
  OneUnresolvedIdentifierOr,
  attribute,
  entity,
  relationship,
} from 'jsonapi-transformers';

import { ReadingIntentionsKey } from '®shared/annotations';
import { BibliographicResource } from '®shared/bibliographic-resource';
import { UserRecord } from '®shared/user/user-record';

type ReadingIntentionsKeyAliased = ReadingIntentionsKey;

type OneUnresolvedIdentifierOrUser = OneUnresolvedIdentifierOr<UserRecord>;
type OneUnresolvedIdentifierOrBibliographicResource =
  OneUnresolvedIdentifierOr<BibliographicResource>;

export abstract class UserAnnotation<
  E extends UserAnnotation<E>,
> extends JsonapiEntity<E> {
  @relationship({ allowUnresolvedIdentifiers: true })
  resource: OneUnresolvedIdentifierOrBibliographicResource;
  @relationship({ allowUnresolvedIdentifiers: true })
  user: OneUnresolvedIdentifierOrUser;
}

@entity({ type: 'reading_intentions' })
export class UserReadingIntention extends UserAnnotation<UserReadingIntention> {
  @attribute() status: ReadingIntentionsKeyAliased;
}

@entity({ type: 'study_notes' })
export class UserStudyNote extends UserAnnotation<UserStudyNote> {
  @attribute() note: string;
}
